import React, { useEffect, useRef, useState } from 'react'
import { Canvas } from '@react-three/fiber'
import { OrbitControls } from '@react-three/drei'
import { data } from '../Utils/Data'
import StartScreen from '../Components/StartScreen'
import Particles from '../Components/Particles'
import Music from '../Components/Music'
import './App.css'

export default function App() {

    const [userInteracted, setUserInteracted] = useState(false)
    const [text, setText] = useState('')
    const img = useRef([null])
    const [imgSelcted, setImgSelected] = useState(0)
    const [model, setModel] = useState(null)
    const controls = useRef()
    const timer = useRef()


    useEffect(() => {
        async function startSequence() {
            for (let i = 0; i < data.length; i++) {
                const type = data[i].type
                switch (type) {
                    case 'Text':
                        await showText(data[i].txt, setText, data[i].timeLine)
                        break
                    case 'Image':
                        await showImage(data[i].img, img, setImgSelected, data[i].timeLine)
                        break
                    case 'Model':
                        await showModel(data[i].model, setModel, data[i].timeLine)
                        break
                }
            }
        }
        if (userInteracted) startSequence()
    }, [userInteracted])


    function resetControl() {
        timer.current = setTimeout(() => {
            controls.current.reset()
        }, 500)
    }

    return (
        <>
            <StartScreen setUserInteracted={setUserInteracted} />
            <Canvas className='canvas' camera={{ position: [0, 0, 100], fov: 100 }} frameloop='always'>
                <OrbitControls ref={controls} position={[0, 0, 100]} autoRotate={model} autoRotateSpeed={0.35}
                    onStart={() => clearTimeout(timer.current)} onEnd={resetControl} />
                <Particles text={text.trim()} img={img.current[imgSelcted]} model={model} />
            </Canvas>
            <Music userInteracted={userInteracted} />
        </>
    )
}

async function showText(dataTxt, setText, timeLine) {

    let words = dataTxt.split(' ')
    for (let i = 0; i < words.length; i++) {
        let time = timeLine[i % timeLine.length]
        await new Promise(resolve => setTimeout(resolve, time))
        setText(prev => prev + words[i] + ' ')
    }
    await new Promise(resolve => setTimeout(resolve, 3000))
    setText('')
}

async function showImage(dataImg, img, setImgSelected, timeLine) {

    dataImg.forEach((src, i) => {
        img.current.push(new Image())
        img.current[i + 1].src = src
    })

    for (let i = 0; i < dataImg.length; i++) {
        let time = timeLine[i % timeLine.length]
        await new Promise(resolve => setTimeout(resolve, time))
        setImgSelected(i + 1)
        await new Promise(resolve => setTimeout(resolve, 8000))
        setImgSelected(0)
    }
    img.current = [null]
}

async function showModel(dataModel, setModel, timeLine) {
    await new Promise(resolve => setTimeout(resolve, timeLine))
    setModel(dataModel)
}